import { Constructor } from '@cawita/core-front';
import 'reflect-metadata';


const CWT_MODEL_CONFIG_METADATA = 'cwt:model:config';

export interface CwtModelConfig {
    name: string;
    path: string;
}

export function CwtModel(config: CwtModelConfig): ClassDecorator {
    return (target) => Reflect.defineMetadata(CWT_MODEL_CONFIG_METADATA, config, target)
}

export function getModelConfig<T>(model: Constructor<T>): CwtModelConfig {
    return Reflect.getMetadata(CWT_MODEL_CONFIG_METADATA, model);
}